import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "../translation/";
import { loadMore } from "../../state/modules/search/actions";
import LoadButton from "./LoadButton";
import {
  getPagePath,
  NEXT_PAGE
} from "../../state/modules/search/pageLinkSelectors";

export function LoadMoreButton({
  isLoadingMore,
  loadMore,
  nextPagePath,
  formatTranslation,
  formatLink
}) {
  return (
    <LoadButton
      loadCallback={loadMore}
      isLoading={isLoadingMore}
      testId="loadMoreProducts"
      linkUrl={formatLink(nextPagePath)}
      formatTranslation={formatTranslation}
    >
      {formatTranslation("plp_web_search_load_more_button_text")}
    </LoadButton>
  );
}

LoadMoreButton.propTypes = {
  isLoadingMore: PropTypes.bool.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  formatLink: PropTypes.func.isRequired,
  loadMore: PropTypes.func.isRequired,
  nextPagePath: PropTypes.string.isRequired
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isLoadingMore: state.search.isLoadingMore,
    nextPagePath: getPagePath({ state, direction: NEXT_PAGE })
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadMore: () => dispatch(loadMore())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(LoadMoreButton));
